import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors) => ({
  rowStart: {
    alignItems: 'flex-start',
  },
  mapPreviewContainer: {
    width: 76,
    height: 76,
    borderRadius: theme.borderRadius.s,
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: colors.backgroundL1Alpha,
  },
  mapPreview: {
    width: '100%',
    height: '100%',
  },
  mapPinOverlay: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    alignItems: 'center',
    justifyContent: 'center',
  },
  mapPin: {
    width: 16,
    height: 16,
    borderRadius: 8,
    backgroundColor: '#0083FF',
    borderWidth: 3,
    borderColor: colors.backgroundL0,
  },
}));
